module.exports = __webpack_public_path__ + "static/img/z-6.2c1c2015.png";